export default __webpack_public_path__ + "static/media/icon_seo.365d63a5.svg";